export const shopInput = "w-full bg-white/70 border border-[#D5B98C] px-3 py-3 text-sm outline-none focus:border-[#39251D] transition-colors";
export const shopBtn = "inline-flex items-center justify-center gap-2 bg-[#39251D] text-[#F5F0E8] px-6 py-3.5 text-xs uppercase tracking-[0.2em] hover:bg-[#956842] transition-colors disabled:opacity-40 disabled:cursor-not-allowed";

export const AddressFields = ({ value, onChange, countries, prefix = "addr" }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const f = (k, ph, props = {}) => <input data-testid={`${prefix}-${k}`} required={!["province", "phone"].includes(k)} placeholder={ph} value={value[k] || ""} onChange={set(k)} className={shopInput} {...props} />;
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="col-span-2">{f("full_name", "Nome e cognome del destinatario")}</div>
      <div className="col-span-2">{f("street", "Indirizzo e numero civico")}</div>
      {f("zip", "CAP")}{f("city", "Città")}
      {f("province", "Provincia (es. FG)")}
      <select data-testid={`${prefix}-country`} value={value.country || "IT"} onChange={set("country")} className={shopInput}>
        {countries.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
      </select>
    </div>
  );
};
